import { CancelHistoryAppointmentDataMapper } from './CancelHistoryAppointmentMapper.types'

class CancelHistoryAppointmentMapper {
  toPersistence(domainData: CancelHistoryAppointmentDataMapper) {
    return { motivoCancelamento: domainData?.reasonCancellation }
  }
}

export default new CancelHistoryAppointmentMapper()
